import { Pipe, PipeTransform } from '@angular/core';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';


@Pipe({
  name: 'assetPipe'
})

export class AssetPipe implements PipeTransform {
  
  
  public transform(asset: Asset, field: string): any {
    let result = asset[field];

    if (field == 'barCode'){
      if (asset.assetCode == asset.barCode) {
        result = ''
      }
      return result;
    }


     if (field == 'assetStatusCode') {
      if  (result == 'Available')           return "<div class='label-blue'  >"  + 'Disponible'          + "</div>";
      if  (result == 'AssignedToPartner')   return "<div class='label-green' >"  + 'Affecté au client'   + "</div>";
      if  (result == 'PendingFromSupplier') return "<div class='label-gray'  >"  + 'Attente fournisseur' + "</div>";
      if  (result == 'PendingToBranch')     return "<div class='label-gray'  >"  + 'Attente > Agence'    + "</div>";
      if  (result == 'PendingToPartner')    return "<div class='label-gray'  >"  + 'Attente > Client'    + "</div>";
      if  (result == 'PendingFromPartner')  return "<div class='label-gray'  >"  + 'Attente < Client'    + "</div>";
      if  (result == 'Decommissioned')      return "<div class='label-gray'  >"  + 'Réformé'             + "</div>";
      if  (result == 'Exit')                return "<div class='label-red'   >"  + 'Sorti du stock'      + "</div>";
    }

    if (field == 'ticketsNumber') {
      if  (result)  {
        return "<div class='label-red'   >  "  + result  + "</div>"
      } else {
        return '';
      }
    }

    if (field == 'closed') {
      if  (result)  {
        return "<div class='label-red'   >  Réformé  </div>"
      } else {
        return '';
      }
    }
    

    if (! result) result = "no thing"
    return result;
  }

}

